// import { useEffect, useMemo, useRef, useState } from "react";
// // import { DateRange } from "react-date-range";
// import { Calendar } from "react-date-range";

// import { addDays, format, isWithinInterval, startOfDay } from "date-fns";
// import { checkPackageAvailability, fetchPackageBookings } from "../api/packageAvailability";

// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";

// const PLACEHOLDER_NIGHTS = 1;

// export default function PackageAvailabilityCalendar({ pkg, onChange }) {
//   const [open, setOpen] = useState(false);
//   const [startDate, setStartDate] = useState(null);
//   const [bookings, setBookings] = useState([]); // [{startDate,endDate}]
//   const [checking, setChecking] = useState(false);
//   const [status, setStatus] = useState(null); // {available,status}
//   const wrapperRef = useRef(null);

//   // Close on outside click
//   useEffect(() => {
//         function handleOutside(e) {
//         if (!wrapperRef.current) return;

//         if (wrapperRef.current.contains(e.target)) return;

//         setOpen(false);
//         }

//     document.addEventListener("mousedown", handleOutside);
//     return () => document.removeEventListener("mousedown", handleOutside);
//   }, []);

//   // Load bookings for this package (for sold-out painting)
//   useEffect(() => {
//     if (!pkg?.slug) return;
//     fetchPackageBookings(pkg.slug)
//       .then((data) => setBookings(Array.isArray(data) ? data : []))
//       .catch(() => setBookings([]));
//   }, [pkg?.slug]);

// const nights = Number.isInteger(pkg?.nights) ? pkg.nights : 0;

 

// const endDate =
//   startDate && nights > 0 ? addDays(startDate, nights) : null;

// const label =
//   startDate && nights > 0
//     ? `${format(startDate, "dd MMM yyyy")} → ${format(endDate, "dd MMM yyyy")} • ${nights} nights`
//     : "Select start date";



//   // Normalize booking ranges into Date objects
//   const bookedIntervals = useMemo(() => {
//     return bookings
//       .map((b) => ({
//         start: startOfDay(new Date(b.startDate)),
//         end: startOfDay(new Date(b.endDate)),
//       }))
//       .filter((b) => !isNaN(b.start) && !isNaN(b.end));
//   }, [bookings]);

//   // A day is booked if it falls inside any confirmed booking interval
//   const isDayBooked = (day) => {
//     const d = startOfDay(day);
//     return bookedIntervals.some((itv) =>
//       isWithinInterval(d, { start: itv.start, end: addDays(itv.end, -1) })
//     );
//   };

//   // Disable booked days + past days
//   const disabledDay = (day) => {
//     const today = startOfDay(new Date());
//     if (startOfDay(day) < today) return true;
//     return isDayBooked(day);
//   };

//   // When user picks dates
// const handleSelect = async (date) => {
//   if (!pkg?.slug) return;

//   setStartDate(date);
//   setChecking(true);

//   try {
//     const startStr = format(date, "yyyy-MM-dd");
//     const res = await checkPackageAvailability(pkg.slug, startStr);

//     setStatus(res);

//     onChange?.({
//       startDate: date,
//       endDate: addDays(date, nights),
//       available: res.available,
//       status: res.status,
//     });

//     if (res?.available && nights > 0) {
//         setOpen(false);
//         }

//   } catch (e) {
//     setStatus(null);
//     onChange?.(null);
//   } finally {
//     setChecking(false);
//   }
// };


//   // Custom day content: show Available / Sold out
//   const renderDayContent = (day) => {
//     const booked = isDayBooked(day);

//     return (
//       <div className="flex flex-col items-center justify-center leading-tight">
//         <div className="text-sm">{day.getDate()}</div>
//         <div className={`text-[9px] font-semibold ${booked ? "text-red-600" : "text-green-600"}`}>
//           {booked ? "Sold out" : "Available"}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="relative" ref={wrapperRef}>
//       {/* INPUTS (Check-in / Check-out) */}
//         <button
//         type="button"
//         onClick={() => setOpen(true)}
//         className="w-full border rounded-xl px-4 py-3 text-left text-sm bg-white hover:bg-slate-50 transition"
//         >
//         <div className="text-xs text-slate-500">Travel dates</div>
//         <div className="font-semibold text-slate-900">{label}</div>
//         </button>


//       {/* STATUS */}
//       <div className="mt-2">
//         {checking && <p className="text-xs text-slate-500">Checking availability...</p>}

//         {!checking && status && (
//           <div
//             className={`text-xs font-semibold inline-flex px-3 py-1 rounded-full ${
//               status.available ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
//             }`}
//           >
//             {status.available ? "Available" : "Sold out"}
//           </div>
//         )}

//         {!status && !checking && (
//           <p className="text-xs text-slate-500">Select your check-in date to check availability</p>
//         )}
//       </div>

//       {/* POPUP CALENDAR */}
//       {open && (
//         <div className="absolute z-50 mt-3 w-full bg-white border rounded-2xl shadow-xl p-3">
//         <Calendar
//         date={startDate || new Date()}
//         onChange={handleSelect}
//         minDate={new Date()}
//         dayContentRenderer={renderDayContent}
//         disabledDay={disabledDay}
//         color="#3a2a00"
//         />


//           <div className="flex justify-end pt-2">
//             <button
//               type="button"
//               className="text-sm font-medium text-slate-600 hover:text-slate-900"
//               onClick={() => setOpen(false)}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }






// import React, { useState, useEffect } from "react";
// import { format, addDays } from "date-fns";
// import { Calendar as CalendarIcon, ArrowRight } from "lucide-react";

// export default function PackageAvailabilityCalendar({ pkg, onChange }) {
//   const [checkIn, setCheckIn] = useState("");
//   const [checkOut, setCheckOut] = useState("");

//   // Get nights from pkg.nights, or parse from duration string as fallback
//   const nights = pkg?.nights || parseInt(pkg?.duration?.split(" ")[0]) || 0;

//   const handleCheckInChange = (e) => {
//     const dateValue = e.target.value;
//     if (!dateValue) return;

//     const startDate = new Date(dateValue);
//     const endDate = addDays(startDate, nights);

//     const formattedStart = format(startDate, "yyyy-MM-dd");
//     const formattedEnd = format(endDate, "yyyy-MM-dd");

//     setCheckIn(formattedStart);
//     setCheckOut(formattedEnd);

//     // Pass data back to parent
//     onChange({
//       checkIn: startDate,
//       checkOut: endDate,
//       nights: nights,
//       available: true, // You can add logic here to check against blocked dates
//     });
//   };

//   return (
//     <div className="space-y-4">
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
//         {/* Check-in Field */}
//         <div className="relative">
//           <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1">
//             Check-In
//           </label>
//           <div className="relative">
//             <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
//             <input
//               type="date"
//               min={format(new Date(), "yyyy-MM-dd")} // Prevent past dates
//               value={checkIn}
//               onChange={handleCheckInChange}
//               className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm focus:ring-2 focus:ring-[#3a2a00] focus:border-transparent outline-none transition-all cursor-pointer"
//             />
//           </div>
//         </div>

//         {/* Auto-calculated Check-out (ReadOnly) */}
//         <div className="relative">
//           <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1">
//             Check-Out (Fixed)
//           </label>
//           <div className="relative">
//             <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-200 pointer-events-none" />
//             <input
//               type="text"
//               readOnly
//               value={checkOut ? format(new Date(checkOut), "PPP") : "Select check-in"}
//               className="w-full pl-10 pr-4 py-3 bg-slate-100 border border-slate-200 rounded-xl text-sm text-slate-500 outline-none cursor-not-allowed"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Visual Range Indicator */}
//       {checkIn && (
//         <div className="bg-[#3a2a00]/5 border border-[#3a2a00]/10 rounded-xl p-3 flex items-center justify-between animate-fadeIn">
//           <div className="flex items-center gap-3">
//             <div className="text-center">
//               <p className="text-[10px] uppercase text-slate-400 font-bold">From</p>
//               <p className="text-sm font-semibold text-slate-900">{format(new Date(checkIn), "MMM dd")}</p>
//             </div>
//             <ArrowRight className="w-4 h-4 text-[#3a2a00]" />
//             <div className="text-center">
//               <p className="text-[10px] uppercase text-slate-400 font-bold">To</p>
//               <p className="text-sm font-semibold text-slate-900">{format(new Date(checkOut), "MMM dd")}</p>
//             </div>
//           </div>
//           <div className="text-right border-l pl-4 border-slate-200">
//             <p className="text-[10px] uppercase text-slate-400 font-bold">Duration</p>
//             <p className="text-sm font-bold text-[#3a2a00]">{nights} Nights</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



















// import React, { useState, useEffect } from "react";
// import { format, addDays, isWithinInterval, parseISO } from "date-fns";
// import { Calendar as CalendarIcon, ArrowRight, AlertCircle, Lock } from "lucide-react";

// export default function PackageAvailabilityCalendar({ pkg, onChange }) {
//   const [checkIn, setCheckIn] = useState("");
//   const [checkOut, setCheckOut] = useState("");
//   const [existingBookings, setExistingBookings] = useState([]);
//   const [error, setError] = useState("");

//   // Priority 1: pkg.nights from DB. Priority 2: Parse from "4 Nights • 5 Days"
//   // const nights = pkg?.nights || parseInt(pkg?.duration?.toString().split(" ")[0]) || 0;
// //   const nights = React.useMemo(() => {
// //   if (Number(pkg?.nights)) return Number(pkg.nights);

// //   // Fallback: extract from duration.en like "5 Nights • 6 Days"
// //   const durationText = pkg?.duration?.en;
// //   if (!durationText) return 0;

// //   const match = durationText.match(/(\d+)\s*Nights?/i);
// //   return match ? Number(match[1]) : 0;
// // }, [pkg]);



// const nights = React.useMemo(() => {
//   // 1️⃣ Explicit nights field (future-proof)
//   if (Number.isFinite(Number(pkg?.nights)) && Number(pkg.nights) > 0) {
//     return Number(pkg.nights);
//   }

//   const duration = pkg?.duration;
//   if (!duration) return 0;

//   let text = "";

//   // 2️⃣ Prefer English explicitly (matches mobile behavior)
//   if (typeof duration === "object" && typeof duration.en === "string") {
//     text = duration.en;
//   }
//   // 3️⃣ Otherwise fallback to any available language
//   else if (typeof duration === "object") {
//     text =
//       Object.values(duration).find(
//         v => typeof v === "string" && v.trim()
//       ) || "";
//   }
//   // 4️⃣ Plain string duration
//   else if (typeof duration === "string") {
//     text = duration;
//   }

//   if (!text) return 0;

//   // 5️⃣ Multilingual night matcher
//   const match = text.match(
//     /(\d+)\s*(night|nights|nuit|nuits|nacht|nachten|noc|nocy|gece|nocí|ноч|ليالي|شب)/i
//   );

//   return match ? Number(match[1]) : 0;
// }, [pkg]);



// useEffect(() => {
//   console.log("📦 Package nights:", nights);
//     console.log("📦 FULL pkg object:", pkg);
//   console.log("📦 pkg.duration:", pkg?.duration);
// }, [pkg]);


//   // Fetch bookings for this slug to block dates
// useEffect(() => {
//   if (pkg?.slug) {
//     // 1. Double check your API prefix. Try adding your full server URL if local (e.g., http://localhost:5000)
//     // 2. Based on your router code, the path is /api/holiday-bookings/:slug/bookings
//     fetch(`/api/holiday-bookings/${pkg.slug}/bookings`) 
//       .then((res) => {
//         // ADD THIS CHECK: If the response isn't JSON, throw error before parsing
//         if (!res.ok) throw new Error('Network response was not ok');
//         const contentType = res.headers.get("content-type");
//         if (!contentType || !contentType.includes("application/json")) {
//           throw new TypeError("Oops, we didn't get JSON!");
//         }
//         return res.json();
//       })
//       .then((data) => {
//         setExistingBookings(data.bookings || []);
//       })
//       .catch((err) => console.error("Booking fetch error:", err));
//   }
// }, [pkg?.slug]);

//   // Logic to check if a range overlaps with existing bookings
//   // const isDateRangeOccupied = (start, end) => {
//   //   return existingBookings.some((b) => {
//   //     const bStart = parseISO(b.checkIn || b.startDate);
//   //     const bEnd = parseISO(b.checkOut || b.endDate);
      
//   //     return (
//   //       (start >= bStart && start < bEnd) || // Start falls inside
//   //       (end > bStart && end <= bEnd) ||     // End falls inside
//   //       (start <= bStart && end >= bEnd)     // New range swallows existing
//   //     );
//   //   });
//   // };


//   const isDateRangeOccupied = (start, end) => {
//   return existingBookings.some((b) => {
//     const bookedStart = new Date(b.checkIn);
//     const bookedEnd = new Date(b.checkOut);

//     return start < bookedEnd && end > bookedStart;
//   });
// };


//   // const handleCheckInChange = (e) => {
//   //   const val = e.target.value;
//   //   if (!val) return;

//   //   // Use parseISO or split to avoid timezone shifting to previous day
//   //   const [year, month, day] = val.split("-");
//   //   const startDate = new Date(year, month - 1, day);
//   //   const endDate = addDays(startDate, nights);

//   //   // Validate against existing bookings
//   //   if (isDateRangeOccupied(startDate, endDate)) {
//   //     setError("This date range includes dates that are already booked.");
//   //     setCheckIn("");
//   //     setCheckOut("");
//   //     onChange({ available: false });
//   //     return;
//   //   }

//   //   setError("");
//   //   setCheckIn(val);
//   //   setCheckOut(format(endDate, "yyyy-MM-dd"));

//   //   // Update Parent state (PackageDetails)
//   //   onChange({
//   //     checkIn: startDate,
//   //     checkOut: endDate,
//   //     nights: nights,
//   //     available: true,
//   //     totalPrice: pkg.price,
//   //   });
//   // };

//   const handleCheckInChange = (e) => {
//   const value = e.target.value;
//   // if (!value || !nights) return;
// if (!value) return;

//   // Avoid timezone issues
//   const [year, month, day] = value.split("-");
//   const startDate = new Date(year, month - 1, day);
//   const endDate = addDays(startDate, nights);

//   // 🚫 Block booked ranges
//   if (isDateRangeOccupied(startDate, endDate)) {
//     setError(`This package is unavailable for ${nights} nights from this date.`);
//     setCheckIn("");
//     setCheckOut("");
//     onChange({ available: false });
//     return;
//   }

//   setError("");
//   setCheckIn(value);
//   setCheckOut(format(endDate, "yyyy-MM-dd"));

//   onChange({
//     checkIn: startDate,
//     checkOut: endDate,
//     nights,
//     available: true,
//     totalPrice: pkg.price,
//   });
// };

//   return (
//     <div className="space-y-4">
//       {/* Selection Fields */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//         <div className="space-y-1">
//           <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-In</label>
//           <div className="relative">
//             <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
//             <input
//               type="date"
//               min={format(new Date(), "yyyy-MM-dd")}
//               value={checkIn}
//               onChange={handleCheckInChange}
//               className="w-full pl-10 pr-4 py-3 bg-white border border-slate-200 rounded-xl text-sm focus:border-[#3a2a00] outline-none transition-all cursor-pointer font-medium"
//             />
//           </div>
//         </div>

//         <div className="space-y-1">
//           <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-Out (Auto)</label>
//           <div className="relative">
//             <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-300 pointer-events-none" />
//             <input
//               type="text"
//               readOnly
//                value={checkOut ? format(parseISO(checkOut), "PPP") : "Auto calculated"}
//               className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-500 outline-none cursor-not-allowed font-medium"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <div className="flex items-center gap-2 p-3 bg-red-50 text-red-600 rounded-lg text-xs font-semibold border border-red-100 animate-pulse">
//           <AlertCircle className="w-4 h-4" />
//           {error}
//         </div>
//       )}

//       {/* Summary Box */}
//       {checkIn && !error && (
//         <div className="p-4 bg-[#3a2a00] rounded-xl text-white shadow-lg space-y-3">
//           <div className="flex items-center justify-between border-b border-white/10 pb-2">
//             <span className="text-[10px] uppercase font-bold text-white/60">Itinerary Summary</span>
//             <span className="text-xs font-bold bg-white/20 px-2 py-0.5 rounded-full">{nights} Nights</span>
//           </div>
          
//           <div className="flex items-center justify-between">
//             <div className="text-center flex-1">
//               <p className="text-lg font-bold">{format(parseISO(checkIn), "dd MMM")}</p>
//               <p className="text-[10px] text-white/60 uppercase">Arrival</p>
//             </div>
            
//             <ArrowRight className="w-5 h-5 text-white/30" />
            
//             <div className="text-center flex-1">
//               <p className="text-lg font-bold">{format(parseISO(checkOut), "dd MMM")}</p>
//               <p className="text-[10px] text-white/60 uppercase">Departure</p>
//             </div>
//           </div>

//           <div className="pt-2 flex justify-between items-end border-t border-white/10">
//             <p className="text-[10px] text-white/60 uppercase">Total Package Price</p>
//             <p className="text-xl font-black">${pkg.price?.toLocaleString()}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }















// import React, { useState, useEffect } from "react";
// import { format, addDays, parseISO } from "date-fns";
// import { Calendar as CalendarIcon, ArrowRight, AlertCircle, Lock } from "lucide-react";
// import { safeString } from "../utils/langUtils";
// // import { checkPackageAvailability, fetchPackageBookings, bookPackage } from '../api';

// import { fetchPackageBookings } from "../api/packageAvailability";


// export default function PackageAvailabilityCalendar({ pkg, onChange }) {
//   const [availability, setAvailability] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [checkIn, setCheckIn] = useState("");
//   const [checkOut, setCheckOut] = useState("");
//   const [existingBookings, setExistingBookings] = useState([]);
//   const [error, setError] = useState("");

//   // Extract nights from duration (multilingual safe)
//   const nights = React.useMemo(() => {
//     const durationText = safeString(pkg?.duration);
//     if (!durationText) return 1;

//     const match = durationText.match(
//       /(\d+)\s*(night|nights|nuit|nuits|nacht|nachten|noc|nocy|gece|nocí|ноч|ليالي|شب)/i
//     );
//     return match ? Number(match[1]) : 1;
//   }, [pkg]);

//   useEffect(() => {
//     fetchPackageBookings(pkg?.slug).then(setExistingBookings);
//   }, [pkg?.slug]);

//   const isDateRangeOccupied = (start, end) =>
//     existingBookings.some((b) => {
//       const bookedStart = new Date(b.checkIn);
//       const bookedEnd = new Date(b.checkOut);
//       return start < bookedEnd && end > bookedStart;
//     });

//   const handleCheckInChange = (e) => {
//     const value = e.target.value;
//     if (!value) return;

//     const [year, month, day] = value.split("-");
//     const startDate = new Date(year, month - 1, day);
//     const endDate = addDays(startDate, nights);

//     if (isDateRangeOccupied(startDate, endDate)) {
//       setError(`This package is unavailable for ${nights} nights from this date.`);
//       setCheckIn("");
//       setCheckOut("");
//       onChange({ available: false });
//       return;
//     }

//     setError("");
//     setCheckIn(value);
//     setCheckOut(format(endDate, "yyyy-MM-dd"));

//     onChange({
//       checkIn: startDate,
//       checkOut: endDate,
//       nights,
//       available: true,
//       totalPrice: pkg.price,
//     });
//   };

//   return (
//     <div className="space-y-4">
//       {/* Selection Fields */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//         <div className="space-y-1">
//           <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-In</label>
//           <div className="relative">
//             <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
//             <input
//               type="date"
//               min={format(new Date(), "yyyy-MM-dd")}
//               value={checkIn}
//               onChange={handleCheckInChange}
//               className="w-full pl-10 pr-4 py-3 bg-white border border-slate-200 rounded-xl text-sm focus:border-[#3a2a00] outline-none transition-all cursor-pointer font-medium"
//             />
//           </div>
//         </div>

//         <div className="space-y-1">
//           <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-Out (Auto)</label>
//           <div className="relative">
//             <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-300 pointer-events-none" />
//             <input
//               type="text"
//               readOnly
//               value={checkOut ? format(parseISO(checkOut), "PPP") : "Auto calculated"}
//               className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-500 outline-none cursor-not-allowed font-medium"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <div className="flex items-center gap-2 p-3 bg-red-50 text-red-600 rounded-lg text-xs font-semibold border border-red-100 animate-pulse">
//           <AlertCircle className="w-4 h-4" />
//           {error}
//         </div>
//       )}

//       {/* Summary Box */}
//       {checkIn && !error && (
//         <div className="p-4 bg-[#3a2a00] rounded-xl text-white shadow-lg space-y-3">
//           <div className="flex items-center justify-between border-b border-white/10 pb-2">
//             <span className="text-[10px] uppercase font-bold text-white/60">Itinerary Summary</span>
//             <span className="text-xs font-bold bg-white/20 px-2 py-0.5 rounded-full">{nights} Nights</span>
//           </div>
//           <div className="flex items-center justify-between">
//             <div className="text-center flex-1">
//               <p className="text-lg font-bold">{format(parseISO(checkIn), "dd MMM")}</p>
//               <p className="text-[10px] text-white/60 uppercase">Arrival</p>
//             </div>
//             <ArrowRight className="w-5 h-5 text-white/30" />
//             <div className="text-center flex-1">
//               <p className="text-lg font-bold">{format(parseISO(checkOut), "dd MMM")}</p>
//               <p className="text-[10px] text-white/60 uppercase">Departure</p>
//             </div>
//           </div>
//           <div className="pt-2 flex justify-between items-end border-t border-white/10">
//             <p className="text-[10px] text-white/60 uppercase">Total Package Price</p>
//             <p className="text-xl font-black">${pkg.price?.toLocaleString()}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }










// import React, { useState, useEffect, useMemo } from "react";
// import { format, addDays, parseISO } from "date-fns";
// import { Calendar as CalendarIcon, ArrowRight, AlertCircle, Lock } from "lucide-react";
// import { safeString } from "../utils/langUtils";
// import { fetchPackageBookings } from "../api/packageAvailability";

// export default function PackageAvailabilityCalendar({ pkg, onChange }) {
//   const [checkIn, setCheckIn] = useState("");
//   const [checkOut, setCheckOut] = useState("");
//   const [existingBookings, setExistingBookings] = useState([]);
//   const [error, setError] = useState("");

//   // Extract nights safely
//   const nights = useMemo(() => {
//     const durationText = safeString(pkg?.duration);
//     if (!durationText) return 1;
//     const match = durationText.match(
//       /(\d+)\s*(night|nights|nuit|nuits|nacht|nachten|noc|nocy|gece|nocí|ноч|ليالي|شب)/i
//     );
//     return match ? Number(match[1]) : 1;
//   }, [pkg]);

//   // Fetch bookings on package load
// useEffect(() => {
//   if (!pkg?.slug) return;

//   const loadBookings = async () => {
//     try {
//       const res = await fetchPackageBookings(pkg.slug);
//       const bookings = Array.isArray(res?.bookings) ? res.bookings : [];
      
//       // Flatten all booked dates
//       const bookedDates = [];
//       bookings.forEach(b => {
//         const start = new Date(b.checkIn);
//         const end = new Date(b.checkOut);
//         let curr = new Date(start);
//         while (curr < end) {
//           bookedDates.push(format(curr, "yyyy-MM-dd"));
//           curr.setDate(curr.getDate() + 1);
//         }
//       });

//       setExistingBookings(bookedDates); // replace with flat date array
//     } catch (err) {
//       console.error("Failed to fetch bookings", err);
//       setExistingBookings([]);
//     }
//   };

//   loadBookings();
// }, [pkg?.slug]);


//   // Check if a date range is occupied
//   const isDateRangeOccupied = (start, end) => {
//     if (!Array.isArray(existingBookings)) return false;
//     return existingBookings.some((b) => {
//       const bookedStart = new Date(b.startDate || b.checkIn);
//       const bookedEnd = new Date(b.endDate || b.checkOut);
//       return start < bookedEnd && end > bookedStart;
//     });
//   };

//   const handleCheckInChange = (e) => {
//     const value = e.target.value;
//     if (!value) return;

//     const [year, month, day] = value.split("-");
//     const startDate = new Date(year, month - 1, day);
//     const endDate = addDays(startDate, nights);

//     if (isDateRangeOccupied(startDate, endDate)) {
//       setError(`This package is unavailable for ${nights} nights from this date.`);
//       setCheckIn("");
//       setCheckOut("");
//       onChange({ available: false });
//       return;
//     }

//     setError("");
//     setCheckIn(value);
//     setCheckOut(format(endDate, "yyyy-MM-dd"));

//     onChange({
//       checkIn: startDate,
//       checkOut: endDate,
//       nights,
//       available: true,
//       totalPrice: pkg.price,
//     });
//   };

//   // Disable booked dates and gray them
//   const getInputBgClass = (date) => {
//     const d = new Date(date);
//     return isDateRangeOccupied(d, addDays(d, nights)) ? "bg-gray-300 cursor-not-allowed" : "bg-white";
//   };

//   return (
//     <div className="space-y-4">
//       {/* Selection Fields */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//         <div className="space-y-1">
//           <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-In</label>
//           <div className="relative">
//             <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
//             <input
//               type="date"
//               min={format(new Date(), "yyyy-MM-dd")}
//               value={checkIn}
//               onChange={handleCheckInChange}
//               className={`w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl text-sm focus:border-[#3a2a00] outline-none transition-all font-medium ${getInputBgClass(checkIn)}`}
//             />
//           </div>
//         </div>

//         <div className="space-y-1">
//           <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-Out (Auto)</label>
//           <div className="relative">
//             <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-300 pointer-events-none" />
//             <input
//               type="text"
//               readOnly
//               value={checkOut ? format(parseISO(checkOut), "PPP") : "Auto calculated"}
//               className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm text-slate-500 outline-none cursor-not-allowed font-medium"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <div className="flex items-center gap-2 p-3 bg-red-50 text-red-600 rounded-lg text-xs font-semibold border border-red-100 animate-pulse">
//           <AlertCircle className="w-4 h-4" />
//           {error}
//         </div>
//       )}

//       {/* Summary Box */}
//       {checkIn && !error && (
//         <div className="p-4 bg-[#3a2a00] rounded-xl text-white shadow-lg space-y-3">
//           <div className="flex items-center justify-between border-b border-white/10 pb-2">
//             <span className="text-[10px] uppercase font-bold text-white/60">Itinerary Summary</span>
//             <span className="text-xs font-bold bg-white/20 px-2 py-0.5 rounded-full">{nights} Nights</span>
//           </div>
//           <div className="flex items-center justify-between">
//             <div className="text-center flex-1">
//               <p className="text-lg font-bold">{format(parseISO(checkIn), "dd MMM")}</p>
//               <p className="text-[10px] text-white/60 uppercase">Arrival</p>
//             </div>
//             <ArrowRight className="w-5 h-5 text-white/30" />
//             <div className="text-center flex-1">
//               <p className="text-lg font-bold">{format(parseISO(checkOut), "dd MMM")}</p>
//               <p className="text-[10px] text-white/60 uppercase">Departure</p>
//             </div>
//           </div>
//           <div className="pt-2 flex justify-between items-end border-t border-white/10">
//             <p className="text-[10px] text-white/60 uppercase">Total Package Price</p>
//             <p className="text-xl font-black">${pkg.price?.toLocaleString()}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }










// import React, { useState, useEffect, useMemo } from "react";
// import { format, addDays, parseISO, startOfMonth, endOfMonth, eachDayOfInterval } from "date-fns";
// import { Calendar as CalendarIcon, ArrowRight, AlertCircle, Lock } from "lucide-react";
// import { safeString } from "../utils/langUtils";
// import { fetchPackageBookings } from "../api/packageAvailability";

// const DAY_SIZE = 40;

// export default function PackageAvailabilityCalendar({ pkg, onChange }) {
//   const [checkIn, setCheckIn] = useState("");
//   const [checkOut, setCheckOut] = useState("");
//   const [existingBookings, setExistingBookings] = useState([]);
//   const [error, setError] = useState("");
//   const [currentMonth, setCurrentMonth] = useState(new Date());

//   // Extract nights safely
//   const nights = useMemo(() => {
//     const durationText = safeString(pkg?.duration);
//     if (!durationText) return 1;
//     const match = durationText.match(
//       /(\d+)\s*(night|nights|nuit|nuits|nacht|nachten|noc|nocy|gece|nocí|ноч|ليالي|شب)/i
//     );
//     return match ? Number(match[1]) : 1;
//   }, [pkg]);

//   // Fetch bookings and flatten into date strings
//   useEffect(() => {
//     if (!pkg?.slug) return;

//     const loadBookings = async () => {
//       try {
//         const res = await fetchPackageBookings(pkg.slug);
//         const bookings = Array.isArray(res?.bookings) ? res.bookings : [];

//         const bookedDates = [];
//         bookings.forEach((b) => {
//           const start = new Date(b.checkIn);
//           const end = new Date(b.checkOut);
//           let curr = new Date(start);
//           while (curr < end) {
//             bookedDates.push(format(curr, "yyyy-MM-dd"));
//             curr.setDate(curr.getDate() + 1);
//           }
//         });

//         setExistingBookings(bookedDates);
//       } catch (err) {
//         console.error("Failed to fetch bookings", err);
//         setExistingBookings([]);
//       }
//     };

//     loadBookings();
//   }, [pkg?.slug]);

//   // Check if a range is free
//   const isRangeAvailable = (start, end) => {
//     let curr = new Date(start);
//     const last = new Date(end);
//     while (curr < last) {
//       if (existingBookings.includes(format(curr, "yyyy-MM-dd"))) return false;
//       curr.setDate(curr.getDate() + 1);
//     }
//     return true;
//   };

//   const handleDayClick = (dateStr) => {
//     const start = new Date(dateStr);
//     const end = addDays(start, nights);
//     const endStr = format(end, "yyyy-MM-dd");

//     if (!isRangeAvailable(dateStr, endStr)) {
//       setError(`This package is unavailable for ${nights} nights from this date.`);
//       setCheckIn("");
//       setCheckOut("");
//       onChange({ available: false });
//       return;
//     }

//     setError("");
//     setCheckIn(dateStr);
//     setCheckOut(endStr);

//     onChange({
//       checkIn: start,
//       checkOut: end,
//       nights,
//       available: true,
//       totalPrice: pkg.price,
//     });
//   };

//   // Generate all days for the current month
//   const daysOfMonth = useMemo(() => {
//     const start = startOfMonth(currentMonth);
//     const end = endOfMonth(currentMonth);
//     return eachDayOfInterval({ start, end });
//   }, [currentMonth]);

//   // Render each day cell
//   const renderDay = (date) => {
//     const dateStr = format(date, "yyyy-MM-dd");
//     const day = date.getDate();
//     const isBooked = existingBookings.includes(dateStr);
//     const isStart = checkIn === dateStr;
//     const isEnd = checkOut === dateStr;
//     const isInRange = checkIn && checkOut && dateStr > checkIn && dateStr < checkOut;

//     const rangeColor = "rgba(58,42,0,0.08)";
//     const selectedColor = "#3a2a00"; // dark brown
//     let textColor = "#111827";
//     if (isStart || isEnd) textColor = "#ffffff";
//     else if (isBooked) textColor = "#a1a1aa";

//     return (
//       <div
//         key={dateStr}
//         className={`flex flex-col items-center justify-center m-0.5 cursor-pointer rounded`}
//         style={{
//           width: DAY_SIZE,
//           height: DAY_SIZE,
//           backgroundColor: isStart || isEnd ? selectedColor : isInRange ? rangeColor : "#fff",
//           border: "1px solid #e5e7eb",
//           opacity: isBooked ? 0.5 : 1,
//         }}
//         onClick={() => !isBooked && handleDayClick(dateStr)}
//       >
//         <span style={{ color: textColor, fontWeight: isStart || isEnd ? 700 : 500 }}>{day}</span>
//         {!isBooked && <span style={{ fontSize: 10, color: "#3a2a00" }}>${pkg.price?.toLocaleString()}</span>}
//         {isBooked && <span style={{ fontSize: 8, color: "#a1a1aa" }}>Booked</span>}
//       </div>
//     );
//   };

//   return (
//     <div className="space-y-4">
//       {/* Calendar */}
//       <div className="flex flex-wrap max-w-md border p-2 rounded-xl">
//         {daysOfMonth.map((d) => renderDay(d))}
//       </div>

//       {/* Check-Out Display */}
//       <div className="flex flex-col md:flex-row gap-3">
//         <div className="space-y-1 flex-1">
//           <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-In</label>
//           <div className="relative">
//             <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
//             <input
//               type="text"
//               readOnly
//               value={checkIn ? format(parseISO(checkIn), "PPP") : "Select check-in"}
//               className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl text-sm outline-none font-medium"
//             />
//           </div>
//         </div>
//         <div className="space-y-1 flex-1">
//           <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-Out</label>
//           <div className="relative">
//             <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-300 pointer-events-none" />
//             <input
//               type="text"
//               readOnly
//               value={checkOut ? format(parseISO(checkOut), "PPP") : "Auto calculated"}
//               className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl text-sm outline-none text-slate-500 cursor-not-allowed font-medium"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <div className="flex items-center gap-2 p-3 bg-red-50 text-red-600 rounded-lg text-xs font-semibold border border-red-100 animate-pulse">
//           <AlertCircle className="w-4 h-4" />
//           {error}
//         </div>
//       )}

//       {/* Summary Box */}
//       {checkIn && !error && (
//         <div className="p-4 bg-[#3a2a00] rounded-xl text-white shadow-lg space-y-3">
//           <div className="flex items-center justify-between border-b border-white/10 pb-2">
//             <span className="text-[10px] uppercase font-bold text-white/60">Itinerary Summary</span>
//             <span className="text-xs font-bold bg-white/20 px-2 py-0.5 rounded-full">{nights} Nights</span>
//           </div>
//           <div className="flex items-center justify-between">
//             <div className="text-center flex-1">
//               <p className="text-lg font-bold">{format(parseISO(checkIn), "dd MMM")}</p>
//               <p className="text-[10px] text-white/60 uppercase">Arrival</p>
//             </div>
//             <ArrowRight className="w-5 h-5 text-white/30" />
//             <div className="text-center flex-1">
//               <p className="text-lg font-bold">{format(parseISO(checkOut), "dd MMM")}</p>
//               <p className="text-[10px] text-white/60 uppercase">Departure</p>
//             </div>
//           </div>
//           <div className="pt-2 flex justify-between items-end border-t border-white/10">
//             <p className="text-[10px] text-white/60 uppercase">Total Package Price</p>
//             <p className="text-xl font-black">${pkg.price?.toLocaleString()}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }





















import React, { useState, useEffect, useMemo } from "react";
import { format, addDays, parseISO, startOfMonth, endOfMonth, eachDayOfInterval, addMonths, subMonths } from "date-fns";
import { Calendar as CalendarIcon, ArrowRight, AlertCircle, Lock, ChevronLeft, ChevronRight } from "lucide-react";
import { safeString } from "../utils/langUtils";
import { fetchPackageBookings } from "../api/packageAvailability";

const DAY_SIZE = 40;

export default function PackageAvailabilityCalendar({ pkg, onChange }) {
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [existingBookings, setExistingBookings] = useState([]);
  const [error, setError] = useState("");
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [isCalendarOpen, setIsCalendarOpen] = useState(false); // Open on click

  // Extract nights safely
  const nights = useMemo(() => {
    const durationText = safeString(pkg?.duration);
    if (!durationText) return 1;
    const match = durationText.match(
      /(\d+)\s*(night|nights|nuit|nuits|nacht|nachten|noc|nocy|gece|nocí|ноч|ليالي|شب)/i
    );
    return match ? Number(match[1]) : 1;
  }, [pkg]);

  // Fetch bookings
  useEffect(() => {
    if (!pkg?.slug) return;

    const loadBookings = async () => {
      try {
        const res = await fetchPackageBookings(pkg.slug);
        const bookings = Array.isArray(res?.bookings) ? res.bookings : [];
        const bookedDates = [];
        bookings.forEach((b) => {
          const start = new Date(b.checkIn);
          const end = new Date(b.checkOut);
          let curr = new Date(start);
          while (curr < end) {
            bookedDates.push(format(curr, "yyyy-MM-dd"));
            curr.setDate(curr.getDate() + 1);
          }
        });
        setExistingBookings(bookedDates);
      } catch (err) {
        console.error("Failed to fetch bookings", err);
        setExistingBookings([]);
      }
    };

    loadBookings();
  }, [pkg?.slug]);

  // Check range availability
  const isRangeAvailable = (start, end) => {
    let curr = new Date(start);
    const last = new Date(end);
    while (curr < last) {
      if (existingBookings.includes(format(curr, "yyyy-MM-dd"))) return false;
      curr.setDate(curr.getDate() + 1);
    }
    return true;
  };

  // Handle day click
  const handleDayClick = (dateStr) => {
    const start = new Date(dateStr);
    const end = addDays(start, nights);
    const endStr = format(end, "yyyy-MM-dd");

    if (!isRangeAvailable(dateStr, endStr)) {
      setError(`This package is unavailable for ${nights} nights from this date.`);
      setCheckIn("");
      setCheckOut("");
      onChange({ available: false });
      return;
    }

    setError("");
    setCheckIn(dateStr);
    setCheckOut(endStr);

    onChange({
      checkIn: start,
      checkOut: end,
      nights,
      available: true,
      totalPrice: pkg.price,
    });
    setIsCalendarOpen(false); // Close calendar after selection
  };

  // Generate month days
  const daysOfMonth = useMemo(() => {
    const start = startOfMonth(currentMonth);
    const end = endOfMonth(currentMonth);
    return eachDayOfInterval({ start, end });
  }, [currentMonth]);

  // Render day
  const renderDay = (date) => {
    const dateStr = format(date, "yyyy-MM-dd");
    const day = date.getDate();
    const isBooked = existingBookings.includes(dateStr);
    const isStart = checkIn === dateStr;
    const isEnd = checkOut === dateStr;
    const isInRange = checkIn && checkOut && dateStr > checkIn && dateStr < checkOut;

    const rangeColor = "rgba(58,42,0,0.08)";
    const selectedColor = "#3a2a00";
    let textColor = "#111827";
    if (isStart || isEnd) textColor = "#ffffff";
    else if (isBooked) textColor = "#a1a1aa";

    return (
      <div
        key={dateStr}
        className="flex flex-col items-center justify-center m-0.5 cursor-pointer rounded"
        style={{
          width: DAY_SIZE,
          height: DAY_SIZE,
          backgroundColor: isStart || isEnd ? selectedColor : isInRange ? rangeColor : "#fff",
          border: "1px solid #e5e7eb",
          opacity: isBooked ? 0.5 : 1,
        }}
        onClick={() => !isBooked && handleDayClick(dateStr)}
      >
        <span style={{ color: textColor, fontWeight: isStart || isEnd ? 700 : 500 }}>{day}</span>
        {!isBooked && <span style={{ fontSize: 10, color: "#3a2a00" }}>${pkg.price?.toLocaleString()}</span>}
        {isBooked && <span style={{ fontSize: 8, color: "#a1a1aa" }}>Booked</span>}
      </div>
    );
  };

  // Month navigation
  const goPrevMonth = () => setCurrentMonth((prev) => subMonths(prev, 1));
  const goNextMonth = () => setCurrentMonth((prev) => addMonths(prev, 1));

  return (
    <div className="space-y-4 relative">
      {/* Check-In / Check-Out */}
      <div className="flex flex-col md:flex-row gap-3">
        <div className="space-y-1 flex-1">
          <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-In</label>
          <div className="relative">
            <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
            <input
              type="text"
              readOnly
              onClick={() => setIsCalendarOpen((prev) => !prev)}
              value={checkIn ? format(parseISO(checkIn), "PPP") : "Select check-in"}
              className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl text-sm outline-none font-medium cursor-pointer"
            />
          </div>
        </div>

        <div className="space-y-1 flex-1">
          <label className="text-[11px] font-bold text-slate-400 uppercase tracking-tight">Check-Out</label>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-300 pointer-events-none" />
            <input
              type="text"
              readOnly
              value={checkOut ? format(parseISO(checkOut), "PPP") : "Auto calculated"}
              className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl text-sm outline-none text-slate-500 cursor-not-allowed font-medium"
            />
          </div>
        </div>
      </div>

      {/* Calendar Popup */}
      {isCalendarOpen && (
        <div className="absolute z-50 top-full mt-2 p-3 bg-white border rounded-xl shadow-lg max-w-md">
          {/* Month Header */}
          <div className="flex justify-between items-center mb-2">
            <button onClick={goPrevMonth} className="p-1 rounded hover:bg-gray-100">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <span className="font-bold text-gray-700">
              {format(currentMonth, "MMMM yyyy")}
            </span>
            <button onClick={goNextMonth} className="p-1 rounded hover:bg-gray-100">
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>

          {/* Days Grid */}
          <div className="flex flex-wrap">
            {daysOfMonth.map((d) => renderDay(d))}
          </div>
        </div>
      )}

      {/* Error Message */}
      {error && (
        <div className="flex items-center gap-2 p-3 bg-red-50 text-red-600 rounded-lg text-xs font-semibold border border-red-100 animate-pulse">
          <AlertCircle className="w-4 h-4" />
          {error}
        </div>
      )}

      {/* Summary Box */}
      {checkIn && !error && (
        <div className="p-4 bg-[#3a2a00] rounded-xl text-white shadow-lg space-y-3">
          <div className="flex items-center justify-between border-b border-white/10 pb-2">
            <span className="text-[10px] uppercase font-bold text-white/60">Itinerary Summary</span>
            <span className="text-xs font-bold bg-white/20 px-2 py-0.5 rounded-full">{nights} Nights</span>
          </div>
          <div className="flex items-center justify-between">
            <div className="text-center flex-1">
              <p className="text-lg font-bold">{format(parseISO(checkIn), "dd MMM")}</p>
              <p className="text-[10px] text-white/60 uppercase">Arrival</p>
            </div>
            <ArrowRight className="w-5 h-5 text-white/30" />
            <div className="text-center flex-1">
              <p className="text-lg font-bold">{format(parseISO(checkOut), "dd MMM")}</p>
              <p className="text-[10px] text-white/60 uppercase">Departure</p>
            </div>
          </div>
          <div className="pt-2 flex justify-between items-end border-t border-white/10">
            <p className="text-[10px] text-white/60 uppercase">Total Package Price</p>
            <p className="text-xl font-black">${pkg.price?.toLocaleString()}</p>
          </div>
        </div>
      )}
    </div>
  );
}
